/**
 * Public route detection.
 *
 * These paths are served without an authenticated session (see
 * `src/routes/public.tsx` and `src/routes/auth.tsx`). Anything NOT matched here
 * is treated as protected — new protected features are covered automatically.
 *
 * Used by `AuthListener` so a stale/expired token being cleared on a public
 * page (e.g. `/blueprint`) does not bounce the visitor to `/auth`.
 */

/** Top-level path segments that are public (matched as exact or prefix). */
const PUBLIC_PATH_PREFIXES = [
  '/onboarding',
  '/sign-up',
  '/external-auth',
  '/blueprint',
  '/auth',
];

export const isPublicPath = (pathname: string): boolean => {
  // Home page.
  if (pathname === '' || pathname === '/') {
    return true;
  }

  // `:id/thank-you` onboarding confirmation pages.
  if (/\/thank-you\/?$/.test(pathname)) {
    return true;
  }

  // Match a known public segment exactly or as a path prefix ("/blueprint" and
  // "/blueprint/x", but not "/blueprintish" or "/dashboard/blueprint-summary").
  return PUBLIC_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};
